import { boundingExtent, Extent } from "ol/extent";
import { initializeTooltips } from "../../util/general_util";
import { POI_Data, POI_TYPE_MAP } from "../../util/tripPlanner_types";
import { clearLayer, enlargeIcon, fitBounds, getPoiMarker_fromPoiId, shrinkIcon } from "../map/helper_functions";
import { display_POI_pins, remove_POI_pins } from "../map/map_displays";
import { handle_add_poi_click } from "../update_trip_utils";
import { get_stop_from_stopID } from "./helper_functions";
import { Coordinate } from "ol/coordinate";
import { Feature } from "ol";
import { Circle } from "ol/geom";

function init_poi_card_hover() {
    $("[unAddedPOI]").off("mouseenter");
    $("[unAddedPOI]").on("mouseenter", function() {
        const poiID:number = parseInt(this.getAttribute("poi_id"));
        if (Number.isNaN(poiID)) return;
        const poiMarker = getPoiMarker_fromPoiId(poiID);
        if (poiMarker != null) enlargeIcon(poiMarker, null);
    });
    $("[unAddedPOI]").off("mouseleave");
    $("[unAddedPOI]").on("mouseleave", function() {
        const poiID:number = parseInt(this.getAttribute("poi_id"));
        if (Number.isNaN(poiID)) return;
        const poiMarker = getPoiMarker_fromPoiId(poiID);
        if (poiMarker != null) shrinkIcon(poiMarker, null);
    });
};

export function display_pois(POIs:POI_Data[], stopID:string)  {
    const stopData = get_stop_from_stopID(stopID, window.tripPlannerCurrentTrip);

    const allPoiTypes = $("[poi-filter]").map((idx, el) => parseInt(el.id)).toArray();

    let selected_poi_types:number[] = [...new Set($("[poi-filter]:checked").map((idx, el) => parseInt(el.id)))];

    if (selected_poi_types.length == 0) {
        selected_poi_types = allPoiTypes;
        selected_poi_types.splice(selected_poi_types.indexOf(2),1);
        selected_poi_types.splice(selected_poi_types.indexOf(28),1);
        $("#clear-poi-filters").addClass("d-none");
    } else {
        $("#clear-poi-filters").removeClass("d-none");
    }

    const viewingSuggestedStop:boolean = $("#stopPopout").attr("suggestedStop") == "true";

    for (let i:number = 0; i < allPoiTypes.length; i++) {
        if (!selected_poi_types.includes(allPoiTypes[i])) {
            $(`[unaddedpoi][type_id="${allPoiTypes[i]}"]`).remove();
            remove_POI_pins(false, [allPoiTypes[i]]);
        };
    };

    let addedCount:number = 0;

    let lats = [], lons = [];
    let max:number = 0;

	for (let i:number = 0; i < POIs.length; i++) {
        if (selected_poi_types.includes(POIs[i].poi_typeID) && $(`[poi_id="${POIs[i].id}"`).length == 0) {
		    $(`[poi_disp]`).append(POIs[i].sidebarHTML);
        };

        if (selected_poi_types.includes(POIs[i].poi_typeID)) {
            addedCount += 1;

            lats.push(POIs[i].loc.latitude);
            lons.push(POIs[i].loc.longitude);

            let latDiff:number = Math.abs(stopData.stop.coords.latitude - POIs[i].loc.latitude);
		    let lonDiff:number = Math.abs(stopData.stop.coords.longitude - POIs[i].loc.longitude);
		    let diff:number = Math.sqrt(latDiff**2 + lonDiff**2);
            if (diff > max) max = diff;
        };
	};

    if (lats.length > 0 && lons.length > 0 && max != undefined) {

        const max_lon = Math.max(...lons);
        const min_lon = Math.min(...lons);
        const max_lat = Math.max(...lats);
        const min_lat = Math.min(...lats);
        const bounds:Extent = boundingExtent([
            [max_lon,max_lat],
            [min_lon, min_lat],
            [max_lon, min_lat],
            [min_lon, max_lat]
        ])
        fitBounds(window.mainTripPlannerMap, bounds);
        clearLayer(window.zoomedClusterMarkerLayer_agStops);
	    clearLayer(window.zoomedClusterMarkerLayer_userStops);

        const lonLat:Coordinate = [stopData.stop.coords.longitude, stopData.stop.coords.latitude];
        const stopCircle:Feature = new Feature(new Circle(lonLat, max*1.2));

        if (stopData.stop.fromUserQuery) {
            window.zoomedClusterMarkerLayer_userStops.getSource().addFeature(stopCircle);
        } else {
            window.zoomedClusterMarkerLayer_agStops.getSource().addFeature(stopCircle);
        };;
    };

	// if (viewingSuggestedStop) {
	// 	const addPoiBtns = $(`[poi_disp]`).find("[add-poi-to-stop]");
	// 	addPoiBtns.removeAttr("add-poi-to-stop");
    //     addPoiBtns.attr("data-bs-toggle","tooltip");
    //     addPoiBtns.attr("title", "Lock this stop to add POIs")
	// 	addPoiBtns.on("click", () => {
	// 		$("[suggestedstoptoast]").addClass("autoBreathingButton");
	// 		setTimeout(() => {
	// 			$("[suggestedstoptoast]").removeClass("autoBreathingButton");
	// 		}, 3000);
	// 	});
	// 	// poi_result_wrap.find("[add-poi-to-stop]").remove();
    //     initializeTooltips();
	// };

    let dist_unit = window.tripPlannerCurrentTrip.filters.dist_unit;
    if (!dist_unit) dist_unit = "mi";

    let radius = $('input[name="poi-radius"]:checked').val();
    if (!radius) radius = 5;
    if (addedCount == 0) {
        const selected_type_names = selected_poi_types.map(function(typeID,idx) {
            return POI_TYPE_MAP[typeID] != undefined? POI_TYPE_MAP[typeID]: "";
        });

        let selected_types_str = selected_type_names.join(", ");
        selected_types_str = selected_types_str.length > 50? selected_types_str.slice(0,50) + "...": selected_types_str;
        $("#no-pois-text").html(`There are no results for ${selected_types_str} within ${radius}${dist_unit}.</br> Try broadening your search radius.`);
        $("#no-pois-disp").removeClass("d-none");

        if (!$("#poi-count-disp").hasClass("d-none")) $("#poi-count-disp").addClass("d-none");
    } else {
        if (!$("#no-pois-disp").hasClass("d-none")) $("#no-pois-disp").addClass("d-none");

        $("#poi-count-text").html(`Showing ${addedCount} results within ${radius}${dist_unit}.`);
        $("#poi-count-disp").removeClass("d-none");
    };

	// if (!noFiltersDisp.hasClass("d-none")) {
	// 	noFiltersDisp.addClass("d-none");
	// };

	// $(`[poi_disp_bg][tab_name="${tabName}"]`).css("background-size",0);

	$("[add-poi-to-stop]").off("click");
	$("[add-poi-to-stop]").on("click", handle_add_poi_click);

	init_poi_card_hover();
	display_POI_pins(POIs, stopID, selected_poi_types);
}